module.exports = __webpack_public_path__ + "media/packs/users/img/icons/Download-c257f33fb7d0c8ec5da8238be6eab3e7.svg";